<script lang="ts">
	import { onMount } from "svelte"
	import { DataHandlerDeviceAdmin, DeviceAdmin } from "luxedo-data"
	import ProjectorMakeSelector from "./ProjectorMakeSelector.svelte"
	import { type ProjectorCommand, ProjectorCommands, type ProjectorMake } from "projector-commands"
	import { ProjectorRemote } from "@projector-control/remote-client"

	let { params } = $props()

	let device: DeviceAdmin = $state()
	let selectedMake: ProjectorMake = $state()

	async function fetchDevice() {
		if (!params.id) return
		const deviceID = params.id
		await DataHandlerDeviceAdmin.pull([deviceID])
		device = DataHandlerDeviceAdmin.get(deviceID)
	}

	async function sendCommand(command: ProjectorCommand) {
		console.log("send command", command)
		const rs232Command = ProjectorCommands[selectedMake]["rs232"][command]
		await device.platoCall("send_rs232_command", [rs232Command])
	}

	onMount(async () => {
		await fetchDevice()
	})
</script>

<div id="remote-app">
	<ProjectorMakeSelector selected={selectedMake} onSelect={(make) => (selectedMake = make)} />
	{#if selectedMake}
		<ProjectorRemote sendProjectorCommand={sendCommand} />
	{/if}
</div>

<style>
	#remote-app {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 0.5rem;
	}

	:global(.overlay:has(#remote-app)) {
		min-width: unset;
	}

	:global(.overlay:has(#remote-app) .close-overlay-button) {
		display: none;
	}
</style>
